import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { RumMidwayCredentialsProvider } from '@amzn/rum-midway-credentials-provider';
import { CURRENT_STAGE } from './contstant/apiEndpoints';

const rumConfig: AwsRumConfig = {
  sessionSampleRate: 1,
  telemetries: ['errors', 'performance', 'http'],
  allowCookies: true,
  enableXRay: true,
  debug: true,
  endpoint: 'https://dataplane.rum.us-west-2.amazonaws.com',
} as AwsRumConfig;

let rumInstance: AwsRum | null = null;
let initPromise: Promise<AwsRum | null> | null = null;

export const initializeRum = (): Promise<AwsRum | null> => {
  if (initPromise) return initPromise;

  initPromise = new Promise<AwsRum | null>((resolve) => {
    try {
      const APPLICATION_REGION = 'us-west-2';

      // Skip RUM initialization for localhost
      if (window.location.origin.includes('localhost')) {
        console.log('RUM disabled for localhost development');
        return resolve(null);
      }

      const stage = CURRENT_STAGE === 'test' ? 'beta' : CURRENT_STAGE;

      // Stage-specific configuration
      // TODO: Replace hardcoded values with deploy-time replacements once verified
      const stageConfig: Record<
        string,
        { appMonitorId: string; account: string; roleName: string }
      > = {
        beta: {
          appMonitorId: '7a361f57-d6bd-4052-bc9e-a275ac9c7e7a',
          account: '643233519531',
          roleName: 'GravionUIWebsite-beta-MidwayAuthenticatedMonitoring-OlEeVxWdrNZb',
        },
        gamma: {
          appMonitorId: 'bf75d614-c1d4-48fe-962b-d90ecf6598b4',
          account: '637460933628',
          roleName: 'GravionUIWebsite-gamma-MidwayAuthenticatedMonitorin-ohmKOCXlgXAh',
        },
        prod: {
          appMonitorId: '31f991e9-23a1-4ffd-bdcb-04b48bd8770c',
          account: '249279055158',
          roleName: 'GravionUIWebsite-prod-MidwayAuthenticatedMonitoring-W0bjExO1tpU7',
        },
      };

      const config = stageConfig[stage] || stageConfig.beta;
      const ROLE_ARN = `arn:aws:iam::${config.account}:role/${config.roleName}`;

      rumInstance = new AwsRum(
        config.appMonitorId,
        '1.0.0',
        APPLICATION_REGION,
        rumConfig,
      );

      // Use window.location.origin for dynamic audience detection
      const mwCredProvider = new RumMidwayCredentialsProvider(
        APPLICATION_REGION,
        window.location.origin,
        ROLE_ARN,
      ).ChainAnonymousCredentialsProvider;

      // Set credentials before enabling
      rumInstance.setAwsCredentials(mwCredProvider);

      mwCredProvider()
        .then(() => {
          rumInstance?.enable();
          console.log('RUM initialized successfully with Midway credentials');
          resolve(rumInstance);
        })
        .catch((e) => {
          console.warn('[RUM] Could not get AWS credentials from Midway:', e);
          resolve(rumInstance);
        });
    } catch (error) {
      console.error('Failed to initialize RUM:', error);
      resolve(null);
    }
  });

  return initPromise;
};

export const getRumInstance = async (): Promise<AwsRum | null> => {
  if (initPromise) await initPromise;
  return rumInstance;
};
